import React from 'react';
import icon from 'assets/images/softwares/ESP1.png';

const Icon = ({ width }) => <img src={icon} alt="ESP" width={width || '25'} />;

export default Icon;
